/**
 * Safely convert any CRM attribute value to a display string.
 * Handles EntityReferences ({Id, Name}), OptionSets ({Value}), and plain values.
 * Never returns "[object Object]".
 */
export function displayValue(value: any): string {
  if (value === null || value === undefined) return '';
  if (typeof value !== 'object') return String(value);

  // EntityReference - show Name
  if ('Name' in value && value.Name) return String(value.Name);

  // OptionSetValue - show numeric value
  if ('Value' in value) return String(value.Value);

  // Fallback for any other object
  return JSON.stringify(value);
}
